module.exports = __webpack_public_path__ + "static/media/S1N3-5.64391a41.svg";